import './ox-popup-code-input.js'

import { html } from 'lit'
import { customElement } from 'lit/decorators.js'
import JSON5 from 'json5'

import { OxGristEditor } from './ox-grist-editor.js'
import { i18next } from '@operato/i18n'
import { openPopup } from '@operato/layout'

@customElement('ox-grist-editor-json5')
export class OxGristEditorJson5 extends OxGristEditor {
  get editorTemplate() {
    var parsed: any = this.value

    if (typeof this.value === 'string') {
      try {
        parsed = JSON5.parse(this.value)
      } catch {}
    }

    const text = parsed == null ? '' : JSON5.stringify(parsed)

    return html` <div tabindex="0">${text}</div> `
  }

  _onclick(e: Event): void {
    e.stopPropagation()
    this.showEditorPopup()
  }

  _onkeydown(e: KeyboardEvent): void {
    const key = e.key
    if (key == 'Enter') {
      e.stopPropagation()
      this.showEditorPopup()
    }
  }

  showEditorPopup() {
    var { mode, language = 'javascript' } = this.column.record?.options || {}

    var change = (value: string) => {
      this.dispatchEvent(
        new CustomEvent('field-change', {
          bubbles: true,
          composed: true,
          detail: {
            before: this.value,
            after: value,
            column: this.column,
            record: this.record,
            row: this.row
          }
        })
      )
    }

    var popup = openPopup(
      html`
        <ox-popup-code-input
          .value=${this.value}
          mode=${mode}
          .confirmCallback=${change.bind(this)}
          language=${language}
        ></ox-popup-code-input>
      `,
      {
        backdrop: true,
        title: i18next.t('title.edit code'),
        help: 'data-grist/grist-editor/code'
      }
    )
  }
}
